import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import AlertStructuresButton from './AlertStructuresButton';

function AlertStructuresInDescription(props) {
  const { structures } = props;

  if (!structures || structures.count() === 0) {
    return null;
  }

  return structures.map((structure, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <AlertStructuresButton {...props} key={`${index}-${structure.get('id')}`} id={structure.get('id')} structureInfo={structure} />
  ));
}

AlertStructuresInDescription.propTypes = {
  structures: PropTypes.instanceOf(List),
};

export default AlertStructuresInDescription;
